import ValueLabel from '@material-ui/core/Slider/ValueLabel';

import { withStyles } from '@material-ui/core/styles';

const CustomValueLabel = withStyles(theme => ({
	offset: {
		top: -17,
		left: props => (props.index === 0 ? 'calc(-50% + -10px)' : 'calc(-50% + 5px)'),
		'& *': {
			backgroundColor: 'transparent',
			color: theme.palette.text.secondary
		}
	}
}))(ValueLabel);

export default CustomValueLabel;
